export enum SoundNamesEnum {
  MouseClick = 'mouse_click',
  Success = 'Success',
  Delete = 'delete',
}
